// extracted by mini-css-extract-plugin
module.exports = {"link":"_17W7D","clickable":"s0eeT","svgRoot":"TG-Zk","nonScalingStroke":"_1UnNA","hasShadow":"_37OKp","hasStroke":"_27iav"};